import { createContext, useContext, useState, ReactNode } from 'react';

interface DataReadinessContextType {
  isDataReady: boolean;
  setDataReady: (ready: boolean) => void;
}

const DataReadinessContext = createContext<DataReadinessContextType | undefined>(undefined);

export function DataReadinessProvider({ children }: { children: ReactNode }) {
  const [isDataReady, setDataReady] = useState(false);

  return (
    <DataReadinessContext.Provider value={{ isDataReady, setDataReady }}>
      {children}
    </DataReadinessContext.Provider>
  );
}

export function useDataReadiness() {
  const context = useContext(DataReadinessContext);
  if (!context) {
    throw new Error('useDataReadiness must be used within a DataReadinessProvider');
  }
  return context;
}

